export default __webpack_public_path__ + "static/media/phone.79fb9f20.svg";